const filterGruppoStrutture = () => {
	const colorMap = {
		"rsa": '#EF7D00',
		"sanita": '#00AAC3',
		/* "appartamenti": '#FFCC00', */
		"cure": '#91BE1E'
	}
	let infoWindows = [];

	const endpoint_base = '/wp-json/api/v1/mappastrutture';
    const urlArray = {     
        sanita          : 'https://sanita.korian.it/',
        rsa             : 'https://www.korian.it',
        /* appartamenti    : 'https://appartamenti.korian.it', */
        cure            : 'https://curedomiciliari.korian.it',
    }
	if ( document.getElementById('gruppo-strutture-vue') ) {
		var app = new Vue({
			el: '#gruppo-strutture-vue',
			data() {
				return {
					strutture : [],
                    page: 1,
					perPage: 12,
					pages: [],	
					totaleStrutture : '',
					loading: true,
					selectedMondo : '',
					selectedTipologia : '',
					selectedRegione : '',
					selectedProvincia : '',
					selectedCitta : '',
					viewType : 'photo',
					mobileTrigger : false
				}
			},
			mounted() {
				const fetchPromises = Object.keys(urlArray).map(key => {
					return fetch(urlArray[key] + endpoint_base)
						.then(res => res.json())
						.then(data => {
							// Modifica gli oggetti in data se mondo è 'cure'
							const dataWithKey = data.map(item => {
								if (key === 'cure') {
									return { ...item, mondo: key, tipologie: {9999:{name:'Assistenza Domiciliare', slug: 'assistenza-domicialire'}} };
								} else {
									return { ...item, mondo: key };
								}
							});
			
							// Aggiungi dataWithKey a this.strutture
							this.strutture = [...this.strutture, ...dataWithKey];
						})
				});
			
				Promise.all(fetchPromises).then(() => {
					this.loading = false;
				});
			},
			updated(){
				this.initMapFilter(document.querySelector('.map-filterstrutture'))
			},
            methods: {
				paginate (posts) {
					let page = this.page;
					let perPage = this.perPage;
					let from = (page * perPage) - perPage;
					let to = (page * perPage);
					return  posts.slice(from, to);
				},
				setPages() {
					let numberOfPages = Math.ceil(this.totaleStrutture / this.perPage);
					this.pages = []; /* svuoto e ri-riempio */
					for (let index = 1; index <= numberOfPages; index++) {
						this.pages.push(index);
					}
				},
				toggleDrop(e){
					let selettoriFiltriSearchInput = document.querySelectorAll(".filters-item.--search .filter-search__input input");				
					let isVisible = e.target.closest(".filters-item").classList.contains('visible-list');

					selettoriFiltriSearchInput.forEach(el => {
						el.closest(".filters-item").classList.remove('visible-list');
					});	

					e.target.closest(".filters-item").classList.toggle('visible-list',!isVisible);			
					
					window.addEventListener('mouseup', function(e){   
						selettoriFiltriSearchInput.forEach(el => {
							if (!el.contains(e.target) && el.closest(".filters-item").classList.contains('visible-list')){
								el.closest(".filters-item").classList.remove('visible-list');
							}
						});
						
					});
				},
				selectCurrentFilterUI(selectedFilter, selectedValue){
					if(selectedFilter == 'regione'){
						this.selectedRegione = selectedValue;
					} else if (selectedFilter == 'provincia'){
						this.selectedProvincia = selectedValue;
					}
					else if (selectedFilter == 'citta'){
						this.selectedCitta = selectedValue;
					}
				},
				highlightResult(current, filter) {
					var str = current;
					var regex = new RegExp(filter, 'i');
					var indexQuery = (str.toLowerCase()).indexOf(filter.toLowerCase());
					var highlightText = str.substring(indexQuery, indexQuery + filter.length);
					return str.replace(regex, '<span class="fw-bold">' + highlightText + '</span>')
				},
				initMapFilter( $el ){
					// Find marker elements within map.
					let $markers = [];
					this.computedStrutture.forEach(el => {
						$markers.push({
							lat: el.lat,
							lng: el.lng,
							mondo: el.mondo,
							regione : el.regione,
							id : el.id_wp,
							url: el.url,
							photo: el.photo,
							tipologie: el.tipologie_sing,
							nome: el.nome,
							citta: el.citta,
							provincia: el.provincia,
						});
					});
					// Create gerenic map.
					let mapArgs = {
						zoom        : 7,
						mapTypeId   : google.maps.MapTypeId.ROADMAP,
						streetViewControl: false,
						mapTypeControl: false,
						fullscreenControl: false,
						center: new google.maps.LatLng(45.64938233894401, 9.281023040554102),
						styles: [
							{
								"featureType": "all",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"saturation": 36
									},
									{
										"color": "#333333"
									},
									{
										"lightness": 40
									}
								]
							},
							{
								"featureType": "all",
								"elementType": "labels.text.stroke",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#ffffff"
									},
									{
										"lightness": 16
									}
								]
							},
							{
								"featureType": "all",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "administrative",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#fefefe"
									},
									{
										"lightness": 20
									},
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "administrative",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"color": "#fefefe"
									},
									{
										"lightness": 17
									},
									{
										"weight": 1.2
									},
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "administrative.province",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"hue": "#ff0000"
									}
								]
							},
							{
								"featureType": "administrative.province",
								"elementType": "labels",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "administrative.province",
								"elementType": "labels.text",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "administrative.province",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "administrative.locality",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f5f5f5"
									},
									{
										"lightness": 20
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f5f5f5"
									},
									{
										"lightness": 21
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#dedede"
									},
									{
										"lightness": 21
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 17
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 29
									},
									{
										"weight": 0.2
									}
								]
							},
							{
								"featureType": "road.arterial",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 18
									}
								]
							},
							{
								"featureType": "road.local",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"lightness": 16
									}
								]
							},
							{
								"featureType": "transit",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f2f2f2"
									},
									{
										"lightness": 19
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#e9e9e9"
									},
									{
										"lightness": 17
									}
								]
							}
						]
					};
				
					var map = new google.maps.Map( $el, mapArgs );
					map.markers = [];
					$markers.forEach( (marker) => {
						this.initMarkerFilter( marker, map );
					});
					this.centerMapFilter( map );
					return map;
				},
				initMarkerFilter( $marker, map ){

					// Get position from marker.
					let lat = $marker.lat;
					let lng = $marker.lng;
					let latLng = {
						lat: parseFloat( lat ),
						lng: parseFloat( lng )
					};
					let mondo = $marker.mondo;
					let regione = $marker.regione;
					let id = $marker.id;
					let markercolor = colorMap[mondo];
				
					let color = '';
				
					if ( markercolor ) {
						if (colorMap[markercolor]  ) {
							color = colorMap[markercolor];
						}else{
							color = markercolor;
						}
					}else if ( mondo ) {
						color = mondo ? colorMap[mondo] : '';
					}else{
						color = '#00AAC3';
					}
					const MAP_MARKER = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z';
					const svgMarker = {
						path: MAP_MARKER,
						fillColor: color,
						fillOpacity: 1,
						strokeWeight: 0,
						scale: 1.4,
						anchor: { x: 12, y: 24 },
					};
				
					// Create marker instance.
					let marker = new google.maps.Marker({
						position : latLng,
						map: map,
						icon: svgMarker,
					});
					if ( regione ) {
						marker.regione = regione;
					}
					if ( id ) {
						marker.id = id;
					}
				
					if ( mondo ) {
						marker.mondo = mondo;
					}
				
					// Append to reference for later use.
					map.markers.push( marker );
					
					// If marker contains HTML, add it to an infoWindow.
					if( $marker.innerHTML != '' ){
						let html = '<article class="item-card item-card__struttura d-flex flex-column h-100 '+$marker.mondo+'" itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem"><figure class="item-card__thumb m-0 flex-shink-0 border-bottom border-gray"><a itemprop="url" href="'+$marker.url+'" target="_blank" tabindex="0"><img class="w-100" src="'+$marker.photo+'" alt="Vittoria"></a><div class="item-card__label p-3">';
					
						let tipologieArr = $marker.tipologie
						tipologieArr.forEach(tipo => {
							html += '<a href="'+$marker.url+'" class="item-card__pill tag-pill --filled-'+$marker.mondo+' text-uppercase">'+tipo+'</a>';
						});

						html += '</div></figure><div class="item-card__content p-3 bg-white d-flex flex-column justify-content-between flex-grow-1 gap-3"><div class="item-card__info"><div class="item-card__title desc-1 century-700"><a class="text-corporate" href="'+$marker.url+'" target="_blank" itemprop="name">'+$marker.nome+'</a></div><div class="desc-2 text-'+$marker.mondo+' d-flex flex-wrap gap-2 align-items-center mt-2"><i class="icon-pin"></i><div class="century-700">'+$marker.citta+'</div> | '+$marker.provincia+'</div></div><a href="'+$marker.url+'" target="_blank" class="cta --filled-'+$marker.mondo+' --reverse justify-content-center border border-2 border-'+$marker.mondo+'">Guarda la struttura</a></div></article>';
				
						// Create info window.
						let infoWindow = new google.maps.InfoWindow({
							content: html
						});
				
						infoWindows.push(infoWindow);
				
						// Show info window when marker is clicked.
						google.maps.event.addListener(marker, 'click', function() {
				
							//close all
							for (let i = 0; i < infoWindows.length; i++) {
								infoWindows[i].close();
							}
							infoWindow.open( map, marker );
				
						});
				
						google.maps.event.addListener(map, 'click', function() {
							infoWindow.close();
						});
				
					}
				
				},
				centerMapFilter( map ){

					// Create map boundaries from all map markers.
					let bounds = new google.maps.LatLngBounds();
					map.markers.forEach(function( marker ){
						bounds.extend({
							lat: marker.position.lat(),
							lng: marker.position.lng()
						});
					});
				
					// Case: Single marker.
					if( map.markers.length == 1 ){
						map.setCenter( bounds.getCenter() );
				
					// Case: Multiple markers.
					} else{
						map.fitBounds( bounds );
					}
				}
			},
            computed: {
				paginatedStrutture(){
					this.totaleStrutture = this.computedStrutture.length;
					return this.paginate(this.computedStrutture);
				},
				computedTipologie(){
					let types = [];
					this.strutture.forEach(item => {
						if(item.tipologie != null){
							Object.values(item.tipologie).forEach(el => {
								if(!types.includes(el.name) ){
									types.push(el.name);
								}
							});
						}
					});
					types.sort();
					return types;
				},
				computedRegioni(){
					let regioni = [];
					this.computedStrutture.forEach(item => {
						if(item.regione != null){
							if(!regioni.includes(item.regione) ){
								regioni.push(item.regione);
							}
						}
					});
					var regioniFiltered = regioni.filter(
						(item) => {	
							let regione = this.selectedRegione ? item.toLowerCase().includes(this.selectedRegione.toLowerCase()) : true
							return regione
						}
					)
					regioniFiltered.sort();
					return regioniFiltered;
				},
				computedProvince(){
					let province = [];
					this.computedStrutture.forEach(item => {
						if(item.provincia != null){
							if(!province.includes(item.provincia) ){
								province.push(item.provincia);
							}
						}
					});
					var provinceFiltered = province.filter(
						(item) => {	
							let provincia = this.selectedProvincia ? item.toLowerCase().includes(this.selectedProvincia.toLowerCase()) : true
							return provincia
						}
					)
					provinceFiltered.sort();
					return provinceFiltered;
				},
				computedCitta(){
					let cities = [];
					this.computedStrutture.forEach(item => {
						if(item.citta != null){
							if(!cities.includes(item.citta) ){
								cities.push(item.citta);
							}
						}
					});
					var citiesFiltered = cities.filter(
						(item) => {	
							let citta = this.selectedCitta ? item.toLowerCase().includes(this.selectedCitta.toLowerCase()) : true
							return citta
						}
					)
					citiesFiltered.sort();
					return citiesFiltered;
				},
                computedStrutture(){	
					let mainFilters = this.strutture.filter(
						(item) => {	
							var mondoResult 		= this.selectedMondo ? (item.mondo == this.selectedMondo) : true
							var typeResult = this.selectedTipologia ? (item.tipologie[this.selectedTipologia] || Object.values(item.tipologie).some(tipologia => tipologia.name === this.selectedTipologia)) : true;
							var regioneResult 		= this.selectedRegione ? (item.regione != null &&  item.regione.toLowerCase().includes(this.selectedRegione.toLowerCase())) : true
							var provinciaResult 	= this.selectedProvincia ? (item.provincia != null &&  item.provincia.toLowerCase().includes(this.selectedProvincia.toLowerCase())) : true
							var cittaResult 		= this.selectedCitta ? (item.citta != null &&  item.citta.toLowerCase().includes(this.selectedCitta.toLowerCase())) : true
							
							return mondoResult && typeResult && regioneResult && provinciaResult && cittaResult
						}
					)
                    return mainFilters.sort((a, b) => {
                        if (a.nome < b.nome) { return -1; }
                        if (a.nome > b.nome) { return 1; }
                        return 0;
                    });						
				}
            },
            watch: { 
				totaleStrutture() {
					this.setPages();
				}
			},
		})
	}
}

export default filterGruppoStrutture;